import { useState, useEffect } from "react";

export const KEYBOARD_EVENTS = {
	keyup: "keyup",
	keydown: "keydown",
};
export const EVENT_KEYS = {
	arrowup: {
		string: "ArrowUp",
		keyCode: 38,
	},
	arrowdown: {
		string: "ArrowDown",
		keyCode: 40,
	},
	arrowleft: {
		string: "ArrowLeft",
		keyCode: 37,
	},
	arrowright: {
		string: "ArrowRight",
		keyCode: 39,
	},
	enter: {
		string: "Enter",
		keyCode: 13,
	},
	escape: {
		string: "Escape",
		keyCode: 27,
	},
};

const useKeyPress = (targetKey) => {
	const [keyPressed, setKeyPressed] = useState(false);

	const downHandler = (event) => {
		const { key, keyCode } = event;
		if (targetKey.string === key && targetKey.keyCode === keyCode) {
			setKeyPressed(true);
			event.preventDefault();
		}
	};

	const upHandler = (event) => {
		const { key, keyCode } = event;
		if (targetKey.string === key && targetKey.keyCode === keyCode) {
			setKeyPressed(false);
			event.preventDefault();
		}
	};

	useEffect(() => {
		window.addEventListener(KEYBOARD_EVENTS.keydown, downHandler);
		window.addEventListener(KEYBOARD_EVENTS.keyup, upHandler);
		return () => {
			window.removeEventListener(KEYBOARD_EVENTS.keydown, downHandler);
			window.removeEventListener(KEYBOARD_EVENTS.keyup, upHandler);
		};
	});
	return keyPressed;
};

export default useKeyPress;
